/* ==========================================================================
   ProductCardHe > Client > image
   ========================================================================== */
const ImageClient = require('@bluekiri/alexandria-contrib-components/components/image-rxjs/client/js');
const configuration = require('../config');

/* Init images Products */
function initImageProduct(instance) {
    /* Reference */
    const result = instance;

    /* Store */

    result.images = [...instance.element.querySelectorAll(`[data-component="ImageRxjs"]`)].map(image =>
        ImageClient(`${instance.selector} [data-component="ImageRxjs"][data-type="${image.getAttribute('data-type')}"]`)
    );
}

/* Init Image Company */
function initCompany(instance, isCompany) {
    /* Exit */
    if (!isCompany) return;

    /* Reference */
    const result = instance;

    /* selector */
    const { selector } = instance;

    /* Company */
    result.company = ImageClient(
        `${selector} [data-component="ImageRxjs"][data-type="${configuration().type.company}"]`
    );
}

/* Init Images */
function initImages(instance) {
    /* Reference */
    const result = instance;

    const { company } = result.config;

    /* Company */
    initCompany(instance, company);

    /* Images Product */
    initImageProduct(instance);
}

module.exports = {
    initImages
};
